import { render, staticRenderFns } from "./BaseModalHeader.vue?vue&type=template&id=7565f190&scoped=true"
import script from "./BaseModalHeader.vue?vue&type=script&lang=js"
export * from "./BaseModalHeader.vue?vue&type=script&lang=js"
import style0 from "./BaseModalHeader.vue?vue&type=style&index=0&id=7565f190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565f190",
  null
  
)

export default component.exports